<template>
  <div class="d-flex flex-column">
    <div
      class="showing-div"
      style="margin-left: 40px; color:#006C6B !important;font-weight: bold;"
    >
      <div v-if="applicantsCount.total != 0">
        <template v-if="applicantsCount.total === 1">
          1名表示 / 1名登録
        </template>
        <template v-else>
          {{ applicantsCount.from }}-{{ applicantsCount.to }}名表示 /
          登録者全体{{ applicantsCount.total }}名
        </template>
      </div>
      <template v-if="!isReviewer">
        <p>
          貴社に興味を持ちキャリア登録した方の中で、あなたに判定依頼されている登録者を表示しています。
          <span style="color: red;">判定完了をお早めに</span> お願いします。
        </p>
      </template>
    </div>
    <div class="listing-type-one d-xl-flex flex-wrap justify-content-between mt-4">
      <div :class="class1">
        <div>
          <input
            type="checkbox"
            v-model="isCheckAll"
            @click="checkAll()"
            style="width: 18px;height: 18px;margin-left: 5px;"
          />
        </div>
        <div class="ml-4 text-c ml-2enter">
          <div class="d-flex">
            <b-dropdown
              id="actionDropdown"
              :text="selectedLabel"
              class="btn-sm-drop dd-button mr-2"
              @shown="$emit('shown')"elected
              @hidden="$emit('hidden')"
              variant="secondary"
            >
              <!-- <b-dropdown-item @click="selectOptionAndSubmit()" v-if="isAdmin">
                {{ firstOption() }}
              </b-dropdown-item> -->
              <b-dropdown-item @click="selectOptionAndSubmit()">
                {{ secondOption() }}
              </b-dropdown-item>
            </b-dropdown>
<!-- 
            <button
              class="bulk-action-btn mt-2"
              @click.prevent="submitAction"
              :disabled="checkSelectedLabel"
            >
              実行
            </button> -->
          </div>
        </div>
        
        <div class="one-right">
          <ul class="nostyle ul-button d-flex justify-content-center">
            <li v-if="isReviewer" style="margin-left: 40px;">
              <button
                type="button"
                class="btn btn-primary btn-search"
                @click="showSearchForm"
                v-show="isReviewer"
              >
                <div
                  class="d-flex align-items-center"
                  style="justify-content: space-evenly;"
                >
                  <i class="fa fa-search" style="transform: scale(1.1);"></i>
                  <span class="font-16">検索</span>
                </div>
              </button>
              <button
                type="button"
                class="btn btn-primary btn-clear ml-4"
                @click="clearSearch"
                v-if="!isNoSearch && isReviewer"
              >
                検索クリア
              </button>
              <button
                type="button"
                class="btn btn-info btn-success ml-4 mr-2"
                @click="showTitleModal"
                v-if="!isNoSearch && isReviewer"
              >
                検索条件保存
              </button>
            </li>
            <li v-if="isReviewer"></li>
          </ul>
        </div>
      </div>

    <div>
      <ul class="nostyle ul-button d-flex justify-content-center">
            <li>
              <div
                class="favorite-wrapper tooltip-container"
                @click="toggleFavoriteApplicants"
              >
                <Favorite :favorite="favoritesOnly" :fromSearchBar="true" />
                <div class="custom-tooltip">ブックマーク絞り込み</div>
              </div>
            </li>

            <li class="list-item-fixed">
              <div
                class="favorite-wrapper tooltip-container"
                v-show="isReviewer"
                @click="showFilterForm"
              >
                <button class="btn-plain btn-heart" v-show="isReviewer">
                  <img src="../../../assets/images/csvBtn.png" alt="CSV出力" style="width: 50px; height: 50px;">
                </button>
                <div class="custom-tooltip">CSV出力</div>
              </div>
            </li>
          </ul>
      </div>
    </div>
    <!-- ends listing-type-one -->
    <FilterForm v-show="isReviewer" />
    <SearchForm v-show="isReviewer" />

    <b-modal
      ref="searchTitle"
      cancel-variant="outline-danger"
      cancel-title="キャンセル"
      ok-title="保存"
      title="検索条件保存"
      @ok.prevent="saveSearch"
      :ok-disabled="isSubmitting"
      @hidden="hideModal"
      modal-class="save-search-modal"
    >
      <form v-on:submit.prevent="saveSearch" data-vv-scope="saveSearch">
        <div class="custom-form-block" style="padding: 20px;">
          <div class="form-group row">
            <div class="col-md-12 mb-30">
              <label>
                検索条件名
                <span class="text-danger">*</span>
              </label>

              <input
                type="text"
                class="form-control"
                v-bind:class="{
                  'is-invalid': errors && errors.title && errors.title.error,
                }"
                name="title"
                v-model="title"
                v-validate="'required'"
                placeholder="検索条件名を入力"
              />
              <div
                class="invalid-feedback"
                v-if="errors && errors.title && errors.title.error"
              >
                <span class="icon-error">!</span>
                {{ errors.title.msg }}
              </div>
            </div>

            <div class="col-md-12 mb-30">
              <div class="d-flex flex-row">
                <label class="mb-2">
                  ログイン時の初期表示条件にする
                  <span class="text-danger">*</span>
                </label>
                <div class="form-check ml-3">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="isDefault"
                    id="isDefaultCheck"
                    value="yes"
                    :checked="isDefault === 'yes'"
                    @click="handleRadioClick"
                    ref="defaultRadio"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ends custom-form-block -->
      </form>
      <template #modal-footer>
        <!-- <div class="modal-footer"> -->
        <button class="btn btn-white" @click="hideModal">キャンセル</button>
        <button class="btn btn-blue" @click="saveSearch">保存する</button>
        <!-- </div> -->
      </template>
    </b-modal>

    <SearchTemplateModal
      ref="searchTemplate"
      :templates="userTemplate"
      :isSubmitting="isSubmitting"
      @hidden="hideModal"
    />

    <ReviewListPopup
      ref="reviewListPopup"
      :showReviewListModal="showReviewListModal"
      :isBulkOperation="true"
      :jobseekerIds="jobseekerIds"
      @hideModal="hideReviewList"
    />

    <ConfirmationPopup
      ref="confirmationPopUp"
      :modalText="detailsText"
      :buttonText="buttonText"
      @submit="processSubmission"
      @cancel="hideConfirmationModal"
      v-if="openConfirmationPopup"
    />
  </div>
</template>

<script>
import Favorite from '@/components/dashboard/applicants/Favorite.vue';
import Interview from '@/components/dashboard/applicants/Interview.vue';
import SearchForm from '@/components/dashboard/applicants/SearchForm.vue';
import FilterForm from '@/components/dashboard/applicants/FilterForm.vue';
import ReviewListPopup from '../ReviewListPopup.vue';
import SearchTemplateModal from './SearchTemplateModal.vue';
import ConfirmationPopup from './profile/ConfirmationPopup.vue';
// import SearchParams from '@/components/dashboard/applicants/SearchParams.vue';
// import Dropdown from '@/components/dashboard/Dropdown.vue';
import mutations from '@/config/mutations';
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
// import Csv from './ApplicantsCsv.vue';
import Api from '@/config/api';
import ApiService from '@/service/apiService';

export default {
  name: 'SearchBar',
  components: {
    SearchForm,
    Favorite,
    Interview,
    FilterForm,
    ReviewListPopup,
    SearchTemplateModal,
    ConfirmationPopup,
    // Csv,
  },
  data() {
    return {
      class1:
        'one-left d-xl-flex align-items-center justify-content-center justify-content-md-start',
      // sortingItems: {
      //   'activity.created_at': '登録日',
      //   last_year_income: '年収',
      //   full_name: '名前',
      // },
      title: '',
      isDefault: 'no',
      errors: {
        title: {
          error: false,
          msg: '',
        },
      },
      isSubmitting: false,
      selectedLabel: '▼ 一括操作',
      showReviewListModal: false,
      // dropdownText: '未判定のみ表示',
      openConfirmationPopup: false,
      isManualChange: false,
    };
  },
  computed: {
    ...mapState({
      applicants: ({ applicant }) => applicant.applicants,
      favoritesOnly: ({ applicant }) => applicant.favoritesOnly,
      interviewsOnly: ({ applicant }) => applicant.interviewsOnly,
      sortBy: ({ applicant }) => applicant.sortBy,
      searchParams: ({ applicant }) => applicant.searchParams,
      checkAllState: ({ applicant }) => applicant.isCheckAll,
      jobseekerIds: ({ applicant }) => applicant.jobseekerIds,
      isJdListSearch: ({ applicant }) => applicant.isJdListSearch,
      // applicantStatusToFilter: ({ applicant }) =>
      //   applicant.applicantStatusToFilter,
    }),
    isCheckAll: {
      get() {
        return this.checkAllState; // Get value from Vuex state
      },
      set(value) {
        this.setCheckAll(value); // Trigger mutation when value changes
      },
    },
    ...mapGetters({
      applicantsCount: 'getApplicantCounts',
      isReviewer: 'isCreateReviewUser',
      isAdmin: 'currentUserIsAdmin',
      userTemplate: 'getCurrentUserSearchTemplate',
      selectedJd: 'jd/getSelectedJd',
    }),
    checkUndeterminedSearchStatus() {
      return (
        this.searchParams &&
        this.searchParams.status &&
        this.searchParams.status.length > 0 &&
        (!this.searchParams.status.includes('未判定') ||
          this.searchParams.status.length > 1)
      );
    },
    checkSelectedLabel() {
      return this.selectedLabel === '一括操作';
    },
    isNoSearch() {
      if (this.selectedJd && Object.keys(this.selectedJd).length > 0) return false;
      return Object.keys(this.searchParams).length === 0 && this.sortBy === '';
    },
    titleState() {
      return this.title.length > 2;
    },
    detailsText() {
      if (this.selectedLabel === '部門に確認依頼') {
        return 'スカウトする求人が選択されていません <br/> このまま判定を依頼しますか？';
      } else {
        return 'スカウトする求人が選択されていません<br/> このままスカウト候補へ追加しますか？';
      }
    },
    buttonText() {
      if (this.selectedLabel === '部門に確認依頼') {
        return '部門に確認依頼';
      } else {
        return 'スカウト候補へ追加';
      }
    },
  },
  methods: {
    ...mapMutations([
      mutations.applicant.TOGGLE_FAVORITES,
      mutations.applicant.TOGGLE_INTERVIEWS,
      mutations.applicant.TOGGLE_SEARCH_MODAL,
      mutations.applicant.TOGGLE_FILTER_MODAL,
      mutations.applicant.CHANGE_SORT_COLUMN,
      mutations.applicant.CHANGE_SEARCH_PARAMS,
      'setApplicantStatusToFilter',
      'setNewTemplate',
      'setCheckAll',
      'setReloadApplicants',
      'setJobseekerIds',
      'mutateApplicantsAfterMultipleStatus',
    ]),
    ...mapMutations({
      clearAll: 'jd/clearAll',
      setSelectedJd: 'jd/setSelectedJd',
    }),
    ...mapActions({
      loadCurrentUserSearchTemplate: 'loadCurrentUserSearchTemplate',
    }),
    handleRadioClick(event) {
      if(this.isDefault === 'yes') {
        this.isDefault = 'no';
        event.target.checked = false;
      } else {
        this.isDefault = 'yes'
      }
    }, 
    firstOption() {
      console.log(this.isAdmin);
      return 'スカウト候補へ追加';
    },
    secondOption() {
      return this.isReviewer ? '部門に確認依頼' : '対象から除外';
    },
    // changeApplicantStatusFilter(status) {
    //   if (status === '未判定のみ表示') {
    //     this.dropdownText = '未判定のみ表示';
    //     this.setApplicantStatusToFilter('未確認');
    //   } else {
    //     this.dropdownText = '全て表示';
    //     this.setApplicantStatusToFilter('全て表示');
    //   }
    // },
    deleteTemplate(id) {},
    editTemplate(template) {},
    updateDefaultTemplate(id) {},
    checkAll() {
      if (this.isCheckAll) {
        this.setCheckAll(true);
      } else {
        this.setCheckAll(false);
      }
    },
    showSearchTemplate() {
      this.loadCurrentUserSearchTemplate();
      this.$refs.searchTemplate.show();
    },
    hideReviewList() {
      this.showReviewListModal = false;
    },
    toggleFavoriteApplicants() {
      this[mutations.applicant.TOGGLE_FAVORITES](!this.favoritesOnly);
    },
    toggleInterviewApplicants() {
      this[mutations.applicant.TOGGLE_INTERVIEWS](!this.interviewsOnly);
    },
    showSearchForm() {
      this[mutations.applicant.TOGGLE_SEARCH_MODAL](true);
    },
    showFilterForm() {
      this[mutations.applicant.TOGGLE_FILTER_MODAL](true);
    },
    clearSearch() {
      this[mutations.applicant.CHANGE_SEARCH_PARAMS]({});
      this.clearAll();
      this.setSelectedJd(null);
      this[mutations.applicant.CHANGE_SORT_COLUMN]('');
    },
    resetDropdown() {
      this.selectedLabel = '▼ 一括操作';
    },
    isJdAssigned() {
      const selectedApplicants = this.applicants.filter(
        (applicant) => this.jobseekerIds.includes(applicant.id) // Changed from _id to id
      );

      // Check if any selected applicant has no marked jobseekers
      const hasUnassignedJd = selectedApplicants.some(
        (applicant) =>
          !applicant.markedjobseekers || applicant.markedjobseekers.length === 0
      );

      return !hasUnassignedJd; // Return true if all have JDs assigned
    },
    async processSubmission() {
      this.openConfirmationPopup = false;
      if (this.selectedLabel === '部門に確認依頼') {
        this.showReviewListModal = true;
      } else if (this.selectedLabel === 'スカウト候補へ追加') {
        this.scoutApplicant();
      }
    },
    hideConfirmationModal() {
      this.openConfirmationPopup = false;
    },
    selectOptionAndSubmit() {
      this.selectedLabel = this.secondOption();
      this.submitAction();
    },
    submitAction() {
      try {
        const actions = {
          部門に確認依頼: () => {
            if (this.isReviewer) {
              this.showReviewListModal = true
              // if (!this.isJdAssigned()) {
              //   this.openConfirmationPopup = true;
              // } else {
              //   this.showReviewListModal = true;
              // }
            }
          },
          スカウト候補へ追加: () => {
            if (!this.isJdAssigned()) {
              this.openConfirmationPopup = true;
            } else {
              this.scoutApplicant();
            }
          },
          対象から除外: () => {
            if (!this.isReviewer) {
              this.excludeApplicant();
            }
          },
        };
        const action = actions[this.selectedLabel];
        if (action) action();
      } catch (error) {
        console.error('Error in submitAction:', error);
      } finally {
        this.resetDropdown();
      }
    },

    async excludeApplicant() {
      this.errors = [];

      if (this.jobseekerIds.length == 0) {
        return;
      } else {
        // this.loading = true;
        ApiService.put(Api.endpoints.REMOVE_FROM_REVIEW_LIST_MULTIPLE, {
          jobseekerIDs: this.jobseekerIds,
          status: '未確認',
          isNewPanel: true,
        })
          .then(({ data }) => {
            this.mutateApplicantsAfterMultipleStatus(data.data);
            this.setCheckAll(false);
            this.setReloadApplicants(true);
          })
          .catch((error) => console.log(error))
          .then(() => {
            // this.loading = false;
            this.setJobseekerIds([]);
            this.setCheckAll(false);
          });
      }
    },

    async scoutApplicant() {
      this.errors = [];
      if (this.jobseekerIds.length == 0) {
        return;
      } else {
        // this.loading = true;
        ApiService.put(Api.endpoints.MULTIPLE_STATUS, {
          jobseekerIDs: this.jobseekerIds,
          status: 'スカウト対象',
          isNewPanel: true,
        })
          .then(({ data }) => {
            // console.log(data.data)
            this.mutateApplicantsAfterMultipleStatus(data.data);
            this.setCheckAll(false);
            this.setReloadApplicants(true);
          })
          .catch((error) => console.log(error))
          .then(() => {
            // this.loading = false;
            this.setJobseekerIds([]);
            this.setCheckAll(false);
          });
      }
    },
    showTitleModal() {
      this.$refs.searchTitle.show();
    },
    hideModal() {
      this.$refs.searchTitle.hide();
      this.title = '';
      this.errors.title.error = false;
      this.errors.title.msg = '';
    },
    async saveSearch() {
      this.isSubmitting = true;
      const check = await this.$validator.validateAll('saveSearch');
      if (check) {
        this.errors.title.error = false;
        this.errors.title.msg = '';
        const params = { title: this.title, is_default: this.isDefault };

        if (this.searchParams) Object.assign(params, this.searchParams);
        if (this.sortBy) Object.assign(params, { sort: this.sortBy });
        Object.assign(params, { isNewPanel: true });
        // if (this.applicantsCount.perPage) {
        //   Object.assign(params, { rowPerPage: this.applicantsCount.perPage });
        // }

        ApiService.post(Api.endpoints.SAVE_SEARCH_TEMPLATE, params) // eslint-disable-next-line
          .then(({ data }) => {
            this.setNewTemplate(data.data);
            this.isSubmitting = false;
            this.hideModal();
            this.title = '';
          })
          .catch(({ response }) => {
            this.parseErrorResponse(response);
            this.isSubmitting = false;
          });
      } else {
        this.isSubmitting = false;
        this.errors.title.error = true;
        this.errors.title.msg = '検索条件名は必須項目です';
      }
    },
  },
  watch: {
    title(value) {
      if (value === '') {
        this.errors.title.error = true;
        this.errors.title.msg = '検索条件名は必須項目です';
      } else {
        this.errors.title.error = false;
        this.errors.title.msg = '';
      }
    },

  },
  mounted() {
    this.loadCurrentUserSearchTemplate();
  },
};
</script>
<style scoped>
input[type="radio"] {
  width: 16px;
  height: 16px;
}
.font-16 {
  font-size: 16px;
}
.form-control::placeholder {
  color: #b3b3b3 !important;
}
>>> .modal-header {
  border-bottom: none !important;
}
>>> .modal-footer {
  border-top: none !important;
  justify-content: space-around !important;
}

.custom-form-block label {
  color: #3c3c3c !important;
  font-size: 14px !important;
}
>>> .save-search-modal >>> .modal-header {
  border-bottom: none !important;
  /* color: #ffffff; */
}
>>> .save-search-modal .modal-title {
  font-size: 20px;
}
.list-item-fixed {
  min-width: 110px;
}
.template-modal .modal-body {
  padding: 0px !important;
}
.btn-plain.template-Btn {
  background-color: #ffffff;
  min-width: 30px;
  width: 30px;
}
table th {
  text-align: center;
}
table td {
  text-align: center;
}
.nostyle li {
  margin-right: 10px;
  padding-right: 10px;
}
>>> .dropdown-menu.show {
  width: 160px;
  min-width: 160px;
}
>>> .dropdown-item {
  font-size: 16px;
  padding: 5px 10px !important;
}
>>> .dropdown-item:hover {
  color: #006c6b !important;
  background-color: #fff;
}
>>> .dropdown .btn-secondary {
  background-color: #fff !important;
  color: #3c3c3c !important;
  height: 50px !important;
  min-width: 200px !important;
  border-radius: 30px !important;
  width: 200px !important;
  font-size: 16px !important;
  font-weight: bold !important;
}
.bulk-action-btn {
  width: 56px;
  min-width: 56px;
  height: 37px;
  background: #d9d9d9;
  font-size: 14px;
  border-radius: 4px;
  color: #3c3c3c;
  border: 1px solid #3c3c3c;
}
.bulk-action-btn::hover {
  opacity: 0.2;
}
.btn-heart i {
  font-size: 25px !important;
}
i {
  font-size: 25px !important;
}
.favorite-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.favorite-wrapper.favorite-border {
  border: 1px solid #787878;
  width: 116px;
  height: 50px;
  border-radius: 4px;
}

.btn-success {
  height: 50px;
  background: #036AC9;
  border-color: #036ac9;
  color: #fff;
  line-height: 10px;
  margin: auto;
  min-width: 170px;
  width: 170px;
  font-size: 16px;
  font-weight: bold;
  padding: 13px 20px;
  border-radius: 30px !important;
}
.favorite-wrapper span {
  font-size: 14px;
  margin-top: 5px;
  font-weight: 500;
  color: #3c3c3c;
}
.btn-search {
  height: 50px;
  line-height: 10px;
  margin: auto;
  border-radius: 30px;
  min-width: 170px;
  width: 170px;
  font-size: 14px;
}
.btn-clear {
  height: 50px;
  background-color: #C4C4C4;
  border-color: #C4C4C4;
  color: #000 !important;
  font-weight: bold;
  font-size: 16px;
  line-height: 10px;
  margin: auto;
  border-radius: 30px;
  min-width: 1709x;
  width: 1709x;
  padding: 13px 20px;
}

.btn-clear:hover,
.btn-clear:focus {
  background-color: #c2c9cc !important;
  border-color: #c2c9cc !important;
}
.one-right .btn-heart:hover i {
  color: #aba2a2;
}

/* Custom Tooltip Styles */
.tooltip-container {
  position: relative;
  display: inline-block;
}

.custom-tooltip {
  visibility: hidden;
  opacity: 0;
  background-color: #787878;
  color: white;
  text-align: center;
  border-radius: 10px;
  padding: 8px 12px;
  position: absolute;
  z-index: 1000;
  top: 125%;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  font-size: 12px;
  font-weight: 500;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  pointer-events: none;
}

.custom-tooltip::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #787878 transparent;
}

.tooltip-container:hover .custom-tooltip {
  visibility: visible;
  opacity: 1;
}
</style>
